import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DecimalPipe} from '@angular/common';
import {CalculatorComponent} from './compontents/calculator/calculator.component';
import {TableComponent} from './compontents/table/table.component';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule, MatTableModule, MatCheckboxModule, MatButtonModule} from '@angular/material';
import {ReactiveFormsModule} from '@angular/forms';
import {CalculateAaeroAgeoService} from './services/calculateAaeroAgeo.service';
import {UwService} from './services/uw.service';
import {CurrentSystemService} from './services/currentSystem.service';
import {WindLoadService} from './services/windLoad.service';


@NgModule({
	imports: [
		BrowserAnimationsModule,
		MatSelectModule,
		MatInputModule,
		MatCheckboxModule,
		ReactiveFormsModule,
		MatTableModule,
		MatButtonModule
	],
	declarations: [CalculatorComponent, TableComponent],
	exports: [CalculatorComponent, TableComponent],
	providers: [CalculateAaeroAgeoService, UwService, CurrentSystemService, WindLoadService, DecimalPipe]
})
export class FiegerCalculatorCoreModule {
}
